/**
 * "Create a virtual account first." (TMMAPP-0116; tmm-api 0153 §F, MM-D-135). A new subscriber
 * starts with no virtual account, so a write that needs one — or a destination list that has none —
 * shows this, with CREATE VIRTUAL ACCOUNT opening the existing create dialog. After creating one
 * the person retries the action themselves.
 */
import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function VirtualAccountRequiredPrompt({
  onCreate,
}: {
  onCreate?: (() => void) | undefined;
}) {
  const { t } = useTranslation();
  return (
    <Alert
      severity="info"
      data-virtual-account-required=""
      action={
        onCreate !== undefined ? (
          <Button color="inherit" size="small" onClick={onCreate}>
            {t('virtualAccounts.createFirst')}
          </Button>
        ) : undefined
      }
    >
      {t('virtualAccounts.required')}
    </Alert>
  );
}
